import { render } from "./PedidoCompraFrete.vue?vue&type=template&id=65bd9df4&scoped=true&ts=true"
import script from "./PedidoCompraFrete.vue?vue&type=script&lang=ts"
export * from "./PedidoCompraFrete.vue?vue&type=script&lang=ts"

import "./PedidoCompraFrete.vue?vue&type=style&index=0&id=65bd9df4&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65bd9df4"]])

export default __exports__